// extracted by mini-css-extract-plugin
export var closeButton = "_b1-0";